// documentos-pago.js
//
// #1809 · documentos antes de pagar (Sebastián, 30-oct-2026: «Construir el paso ya»). El registro promete
// «Cuando te suscribas te pediremos tu cédula y, si ya estás titulado, tu certificado» (#1850 sacó los
// documentos del alta); este paso es el que cumple esa promesa.
//
// La REGLA (a quién se le exige, qué papeles, qué pasa con PENDING/REJECTED) la decide el backend y viaja en
// `GET /api/billing/me/checkout/` → `documentos` (billing/documentos_pago.py,
// spec en `.claude/specs/1809-docs-pago/`). Acá solo se lee: el front no recalcula quién está exento,
// para que el POST del checkout (400 `documentos_requeridos`) y la pantalla digan lo mismo.
//
//   documentos: {
//     exige: bool,                       // true = no se puede pagar sin subirlos
//     estado: "faltan" | "rechazados" | "enviados" | "aprobados" | "no_aplica",
//     pide: "carnet-y-certificado" | "solo-carnet",
//     nota_rechazo: "",                  // lo que escribió el admin al rechazar (solo con "rechazados")
//     profesion: "DOCTOR" | "INTERNO" | ..., // la que dedujo el back; se manda al subir los papeles
//   }
//
// Sin la clave (backend anterior a este cambio) no hay paso: falla abierta, igual que `access` en
// SuscripcionGate (R33 del item 862). El back nuevo igual rechaza el POST si faltan.

/** Lo que el bloque de pago necesita saber de los documentos de esta cuenta. */
export const documentosDelCheckout = (estadoCheckout) => {
  const d = estadoCheckout?.documentos;
  if (!d || typeof d !== "object") return { exige: false, estado: "no_aplica", pide: "carnet-y-certificado", notaRechazo: "", profesion: "" };
  return {
    exige: d.exige === true,
    estado: d.estado || "no_aplica",
    pide: d.pide === "solo-carnet" ? "solo-carnet" : "carnet-y-certificado",
    notaRechazo: d.nota_rechazo || "",
    profesion: d.profesion || "",
  };
};
